<template>
    <!-- <router-view /> -->
    <router-view v-slot="{ Component }">
        <keep-alive>
            <component :is="Component" v-if="$route.meta.keepAlive" />
        </keep-alive>
        <component :is="Component" v-if="!$route.meta.keepAlive" />
    </router-view>
</template>

<script>
import axios from "@/assets/http";
import api from "@/api/index";
import util from "@/assets/util";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import UAParser from "ua-parser-js";
import { useRoute } from "vue-router";

export default {
    data() {
        return {};
    },
    mounted() {
        if (!localStorage.getItem("wellcee.did")) {
            this.getDeviceId();
        }
        const route = useRoute();
        if (route.query.theme == 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
        }
    },
    methods: {
        // 获取设备ID
        getDeviceId() {
            const parser = new UAParser();
            const parserResult = parser.getResult();
            console.log(parserResult);

            FingerprintJS.load().then((fp) => {
                fp.get().then((result) => {
                    const visitorId = result.visitorId;
                    const timezone = result.components.timezone.value;

                    const source = util.getQueryVariable("source");
                    api.common
                        .getDeviceId({
                            source: source || "web",
                            fingerprint: visitorId,
                            timezone: timezone,
                            browser: parserResult.browser.name,
                            browser_version: parserResult.browser.version,
                            engine: parserResult.engine.name,
                            engine_version: parserResult.engine.version,
                            os: parserResult.os.name,
                            os_version: parserResult.os.version,
                            device: parserResult.device.vendor,
                            device_version: parserResult.device.model,
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                axios.defaults.headers.common["Wellcee-DID"] =
                                    res.data.did;
                                localStorage.setItem(
                                    "wellcee.did",
                                    res.data.did
                                );
                                history.go(0);
                            } else {
                                console.log(res.msg);
                            }
                        });
                });
            });
        },
    },
};
</script>

<style>
:root{
    --wlc-bg-white: rgba(255, 255, 255, 1);
    --wlc-bg-white-2: rgba(251, 251, 251, 1);
    --wlc-bg-color: rgba(248, 248, 248, 1);
    --wlc-text-color: rgba(17, 17, 17, 1);
    --wlc-text-gray-color: rgba(153, 153, 153, 1);
    --wlc-border-color: rgba(245, 245, 245, 1);
    --wlc-primary-color: rgba(45, 182, 182, 1);
}
[data-theme="dark"]{
    --wlc-bg-white: rgba(23, 24, 27, 1);
    --wlc-bg-white-2: rgba(23, 23, 26, 1);
    --wlc-bg-color: rgba(18, 18, 18, 1);
      --wlc-text-color: rgba(210, 217, 233, 1);
    --wlc-text-gray-color: rgba(153, 153, 153, 1);
    --wlc-border-color: rgba(18, 18, 18, 1);
    --wlc-primary-color: rgba(12, 138, 137, 1);
}
body {
    background-color: var(--wlc-bg-color);
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    background-color: var(--wlc-bg-color);
}
.wui-container {
    min-height: 100vh;
    max-width: 500px;
    margin: 0 auto;
    background-color: var(--wlc-bg-color);
}

.wx-download-app-tip {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10000;
    background-color: #ffffff;
}
.wx-download-app-tip img {
    width: 100%;
}
</style>
